import updateProofOfAddressModal from './update-proof-of-address-modal.json';
import updateProofOfAddressChooseDocument from './update-proof-of-address-choose-your-documents.json';
import updateProofOfAddressData from './update-proof-of-address-data.json';
import updateProofOfAddressAttachYourDocument from './update-proof-of-address-attach-your-document.json';
import updateProofOfAddressWealthSuccess from './update-proof-of-address-wealth-success.json';
import updateProofOfAddressPocketSuccess from './update-proof-of-address-pocket-success.json';

export default {
  'update-proof-of-address': {
    ...updateProofOfAddressModal,
    ...updateProofOfAddressChooseDocument,
    ...updateProofOfAddressData,
    ...updateProofOfAddressAttachYourDocument,
    ...updateProofOfAddressWealthSuccess,
    ...updateProofOfAddressPocketSuccess,
  },
};
